module.exports = __webpack_public_path__ + "img/9.4450554a.png";